import styled from 'styled-components';

export const StyledCompanySelect = styled.div`
  display: flex;
  vertical-align: middle;
  max-width: 100rem;
  width: 100%;
  align-items: center;
  text-align: left;
`;

export const StyledCompanySize = styled.span`
  margin-right: 1rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledCompanySearch = styled.div`
  flex: 1;
  text-align: left;
  width: 78rem;
  color: ${({ theme }) => theme.colors.text.main};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 38rem;
  }

  @media screen and (min-width: 150.4rem) {
    width: 92rem;
  }
`;
